'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var AccordionGroup = require('./AccordionGroup.js');
require('./AccordionIcon.scss.js');
require('./Accordion.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Accordion = function (props) {
    var title = props.title, children = props.children, className = props.className;
    var _a = AccordionGroup.useAccordionGroupContext(), activeId = _a.activeId, getUniqueId = _a.getUniqueId, setActiveId = _a.setActiveId;
    var _b = React.useState(props.defaultOpen || false), isOpen = _b[0], setOpen = _b[1];
    var _c = React.useState(), uniqueId = _c[0], setUniqueId = _c[1];
    React.useEffect(function () {
        getUniqueId && setUniqueId(getUniqueId());
    }, [getUniqueId]);
    React.useEffect(function () {
        if (activeId && activeId !== uniqueId && isOpen) {
            setOpen(false);
        }
    }, [activeId]);
    var close = function () {
        setOpen(false);
    };
    var open = function () {
        setOpen(true);
        setActiveId && setActiveId(uniqueId);
    };
    var toggle = function () {
        if (isOpen) {
            close();
        }
        else {
            open();
        }
    };
    return (React__default['default'].createElement("div", { className: "accordion " + ((className === null || className === void 0 ? void 0 : className.container) || '') },
        React__default['default'].createElement("div", { className: "title " + ((className === null || className === void 0 ? void 0 : className.title) || ''), onClick: toggle },
            React__default['default'].createElement("div", null, title),
            React__default['default'].createElement(Icon, { isOpen: isOpen })),
        isOpen && (React__default['default'].createElement("div", { className: "content  " + ((className === null || className === void 0 ? void 0 : className.content) || '') }, children))));
};
var Icon = function (_a) {
    var isOpen = _a.isOpen;
    return (React__default['default'].createElement("div", { className: "accordion-icon " + (isOpen && 'open') },
        React__default['default'].createElement("span", null),
        React__default['default'].createElement("span", null)));
};

exports.Accordion = Accordion;
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map
